import { Member } from 'modules/overlay-v2/domain/interfaces/game-info/gameInfoMapped';
import { Fouls, Goals, ShootoutScore, Team as StateTeam, Teams } from 'modules/overlay-v2/domain/interfaces/game-info/state';
import parseInfoEvent from 'modules/overlay-v2/store/game-info/utils/parse-info.event';
// Контракт данных для канвы принадлежит канве — этот файл под него конвертирует.
import type { Player, Team } from 'modules/overlay-canvas/addons/replacer/replace-event';
import { MatchEvent } from 'shared/types/match-event';

export interface IData {
  players?: {
    first?: Player;
    second?: Player;
  };
  teams?: {
    team?: Team;
    reversedTeam?: Team;
  };
  currentPeriod?: number;
  eventMinute?: number;
}

interface IConvertorData {
  teams?: Teams;
  goals: Goals;
  fouls: Fouls;
  shootoutGoals: ShootoutScore;
  shootoutMisses: ShootoutScore;
}

function convertorEventToReplacer(event: MatchEvent, data: IConvertorData): IData {
  const { teams, goals, fouls, shootoutGoals, shootoutMisses } = data;

  let firstPlayer: Member | undefined = undefined;
  let secondPlayer: Member | undefined = undefined;
  const members = [...(teams?.first?.members ?? []), ...(teams?.second?.members ?? [])];

  for (const member of members) {
    if (firstPlayer && secondPlayer) break;
    if (member?.id === event?.players?.[0]?.id) {
      firstPlayer = member;
    }
    if (member?.id === event?.players?.[1]?.id) {
      secondPlayer = member;
    }
  }

  const parsedTeam = event?.teamId && teams ? parseInfoEvent(event, teams) : undefined;
  const parsedReverse = event?.teamId && teams ? parseInfoEvent(event, teams, { teamReverse: true }) : undefined;

  return {
    players: {
      first: firstPlayer ? convertMember(firstPlayer) : undefined,
      second: secondPlayer ? convertMember(secondPlayer) : undefined,
    },
    teams: {
      team:
        parsedTeam && parsedTeam.team
          ? convertorTeam({
              team: parsedTeam.team,
              goals: goals[parsedTeam.teamPrefix],
              fouls: fouls[parsedTeam.teamPrefix],
              shootoutGoals: shootoutGoals[parsedTeam.teamPrefix],
              shootoutMisses: shootoutMisses[parsedTeam.teamPrefix],
            })
          : undefined,
      reversedTeam:
        parsedReverse && parsedReverse.team
          ? convertorTeam({
              team: parsedReverse.team,
              goals: goals[parsedReverse.teamPrefix],
              fouls: fouls[parsedReverse.teamPrefix],
              shootoutGoals: shootoutGoals[parsedReverse.teamPrefix],
              shootoutMisses: shootoutMisses[parsedReverse.teamPrefix],
            })
          : undefined,
    },
    currentPeriod: event.period,
    eventMinute: event.minutes,
  };
}

export default convertorEventToReplacer;

function convertMember(member: Member): Player {
  return {
    avatar: member.photo,
    name: member.name,
    lastName: member.surname,
    middleName: member.middleName,
    number: member.number,
    qtyRedCards: member.qtyRedCardsMatch,
    qtyYellowCards: member.qtyYellowCardsMatch,
    qtyShootoutGoals: member.qtyShootoutGoalsMatch,
    qtyShootoutMisses: member.qtyShootoutMissesMatch,
  };
}

function convertorTeam(data: { team: StateTeam; goals: number; fouls: number; shootoutGoals: number; shootoutMisses: number }): Team {
  const { team, fouls, goals, shootoutGoals, shootoutMisses } = data;

  return {
    score: goals,
    logo: team.logo,
    name: team.name,
    shortName: team.shortName,
    fouls,
    shootoutGoals,
    shootoutMisses,
  };
}
